export const SUPPORTER_COOKIE_VALUE = "true"
